export function normalizeExternalUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  if (/^\/\//.test(url)) {
    return url;
  }

  return `//${url}`;
}